import { useCallback } from 'react';

import { useScreenMessage } from '@gogame/screens';

import { loadLog } from '../source/log';

export const useLoadLog = () => {
  const { showErrorMessage } = useScreenMessage();
  return useCallback(
    params => {
      return loadLog(params).catch(e => {
        showErrorMessage(e.message);
        return Promise.reject(e);
      });
    },
    [showErrorMessage]
  );
};
